import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import AcceptConcurrentMessagingSession from 'actions/concurrent_messaging/accept_concurrent_messaging_session';
import Button, { ButtonTypes } from 'components/common/button';
import connect from 'components/lib/connect';
import ProfileAvatar from 'components/lib/profile_avatar';

export function AcceptChatWindow({ agentAvatarUrl, agentName, customerName, onAcceptChat }) {
  return (
    <div className="acceptChat">
      <div className="acceptChat-Avatar">
        <ProfileAvatar isLarge profile={{ image: agentAvatarUrl, name: agentName }} />
      </div>
      <div className="acceptChat-content">
        Accept chat to assist <div className="acceptChat-content-name">{customerName}</div>
      </div>
      <Button className="acceptChat-button" onClick={onAcceptChat} buttonType={ButtonTypes.SECONDARY}>
        Accept Chat
      </Button>
    </div>
  );
}

AcceptChatWindow.propTypes = {
  agentAvatarUrl: PropTypes.string,
  agentName: PropTypes.string,
  customerName: PropTypes.string,
  onAcceptChat: PropTypes.func.isRequired,
};

const AcceptChatContainer = connect(mapStateToProps, mapExecuteToProps)(AcceptChatWindow);
export default AcceptChatContainer;

function mapStateToProps({ getProvider }) {
  let conversationId = getProvider('currentLocation').get().currentConversationId;
  let conversation = getProvider('conversations').findBy({ id: conversationId });
  let conversationOwningAgentId = _.get(conversation, 'assignee.agentId');
  let conversationOwningAgent = getProvider('agents').findBy({ id: conversationOwningAgentId });
  let customer = getProvider('profile').get();
  return {
    agentAvatarUrl: _.get(conversationOwningAgent, 'avatarUrl'),
    agentName: _.get(conversationOwningAgent, 'name', 'Agent'),
    customerName: _.get(customer, 'name', 'Customer'),
  };
}

function mapExecuteToProps(executeAction, props) {
  return {
    onAcceptChat: evt => {
      evt.preventDefault();
      executeAction(AcceptConcurrentMessagingSession);
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/composition/accept_chat_window.jsx